<template>
  <div class="form-group">
    <label>{{ label }}</label>
    <select class="form-control" v-model="selectedOption">
      <option :value="null">Please select {{ selectAppend != '' ? selectAppend : label.toLowerCase() }} </option>
<!--      <option :value="null">Please select {{ label.toLowerCase() }} </option>-->
      <option :key="index" :value="option" v-for="(option, index) in options">
        {{ resolve(labelValue, option) }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  props: ['url', 'label', 'labelValue', 'modelValue','externalData','selectAppend'],
  mounted() {
    this.getValetData()
  },
  data() {
    return {
      options: [],
      selectedOption: null
    }
  },
  methods: {
    getValetData() {
      if(this.url == ''){
        return
      }
      this.makeRequest('post', this.url, {}, {}, false).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          let responseData = callResponse.response.data.data
          if (code == 200) {
            this.options = responseData
          }
        }

      });
    },
    resolve(data, obj) {
        var value = data.split('.').reduce(function(prev, curr) {
            return prev ? prev[curr] : null
        }, obj || self)
        if(typeof(data.alter) != "undefined") {
            return data.alter(value)
        }else {
            return typeof(value) != "undefined"? value: '-'
        }
    },
  },
  watch: {
    selectedOption(val) {
      this.$emit('update:modelValue', val)
    },
    modelValue(val) {
      this.selectedOption = val
    },
    url(val){
      if(val != ''){
        if(this.externalData){
          this.options = this.externalData
        }else{
          this.getValetData()
        }
      }
    }
  }
}
</script>
